
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  useSidebar
} from "@/components/ui/sidebar";
import { SidebarNavigation } from "./sidebar/SidebarNavigation";
import { SidebarHeader as SidebarHeaderContent } from "./sidebar/SidebarHeader";
import { SidebarFooterContent } from "./sidebar/SidebarFooterContent";

const SIDEBAR_STATE_KEY = "sidebar-state";

export function AppSidebar() {
  const { logout } = useAuth();
  const { state, toggleSidebar } = useSidebar();

  useEffect(() => {
    // Load sidebar state from localStorage
    const savedSidebarState = localStorage.getItem(SIDEBAR_STATE_KEY);
    if (savedSidebarState === "collapsed" || savedSidebarState === "expanded") {
      // Use a slight delay to avoid hydration issues
      setTimeout(() => {
        if ((savedSidebarState === "collapsed" && state === "expanded") ||
            (savedSidebarState === "expanded" && state === "collapsed")) {
          toggleSidebar();
        }
      }, 0);
    }
  }, []);

  // Store sidebar state in localStorage when it changes
  useEffect(() => {
    if (state) {
      localStorage.setItem(SIDEBAR_STATE_KEY, state);
    }
  }, [state]);

  return (
    <Sidebar variant="sidebar" collapsible="icon">
      <SidebarHeader>
        <SidebarHeaderContent />
      </SidebarHeader>
      <SidebarContent>
        <SidebarNavigation />
      </SidebarContent>
      <SidebarFooter>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarFooterContent />
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarFooter>
    </Sidebar>
  );
}
